// extracted by mini-css-extract-plugin
module.exports = {"Input":"style_Input__2WkZs"};